export const focusLeaves = (event: FocusEvent, element: HTMLElement) =>
  !element.contains(event.relatedTarget as Nullable<Node>);
